export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "fr": {
        "declared_at": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Déclaré le"])},
        "store": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Marchand"])},
        "price": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Prix"])},
        "reason": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Raison"])},
        "tracking_number": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Numéro de suivi"])},
        "valuation_amount": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Valorisation"])},
        "certificate": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Certificat d'irréparabilité"])},
        "link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Lien"])}
      },
      "en": {
        "declared_at": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Declared on"])},
        "store": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Merchant"])},
        "price": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Price"])},
        "reason": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Reason"])},
        "tracking_number": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tracking number"])},
        "valuation_amount": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Valuation"])},
        "certificate": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Irreparability certificate"])},
        "link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Link"])}
      }
    }
  })
}
